import React from "react";
import classNames from "classnames";
import "./DiarioOficialCard.scss";
import {Link} from "react-router-dom";
import Card from "react-bootstrap/Card";
import {DiarioType} from "@types";

interface IDiarioOficialCardProps {
  diario: DiarioType;
  image: string;
  title: string;
  link: string;
  isSelected?: boolean;
  onSelectDiario?: Function;
  applyMouseHoverEffect?: boolean;
}

function DiarioOficialCard({
  diario,
  image,
  title,
  link = "#",
  isSelected = false,
  onSelectDiario = () => {},
  applyMouseHoverEffect = true,
}: IDiarioOficialCardProps): JSX.Element {
  return (
    <div
      className={classNames({
        "do-card-wrapper": true,
        "do-card-wrapper--selected": true,
      })}
    >
      <Link to={link}>
        <Card
          className={classNames({
            "do-card": true,
            "do-card--selected": isSelected,
            "do-card--apply-hover-effect": applyMouseHoverEffect,
          })}
          style={{
            border: "none",
            textAlign: "center",
            borderRadius: "10px",
            height: "90%",
            backgroundColor: "#eeeeee",
          }}
          onClick={() => onSelectDiario(diario)}
        >
          <Card.Img
            variant="top"
            src={image}
            style={{maxWidth: "70%", margin: "25px auto 0 auto"}}
          />
          <Card.Body>
            <Card.Title style={{fontSize: "0.9rem", textAlign: "center"}}>
              {title}
            </Card.Title>
          </Card.Body>
        </Card>
      </Link>
    </div>
  );
}

export default DiarioOficialCard;
